module.exports = __webpack_public_path__ + "img/avatar_ico8.ccf7c3d6.jpg";